import { getTopicByArticleKey } from './topic';
import { getArticleByKey } from './article';
import ActionTypes from '../constants/ActionTypes';

export function getCategories(state) {
  return Object.values(state.category.list);
}

export function getCategory(state, id) {
  return state.category.list[id] || {};
}

export function getCategorySuggestions(state) {
  return state.category.suggestionsList;
}

export function isCategoryLoaded(state, key) {
  return !!(
    state.categories.status[key] &&
    state.categories.status[key] === ActionTypes.FETCH_CATEGORY_SUCCESS
  );
}

export function getTopicCatgoryByArticleKey(state, articleKey) {
  const { categoryKey } = getTopicByArticleKey(state, articleKey);
  return getCategoryByKey(state, categoryKey);
}

export function getCatgoryByArticleKey(state, articleKey) {
  const { categoryKey } = getArticleByKey(state, articleKey);
  return getCategoryByKey(state, categoryKey);
}

export function getCategoryByKey(state, key) {
  return state.categories.list[key] || {};
}

export function getCategoryDetails(state) {
  return { ...state.category.category } || {};
}
